import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="theme-language"
export default class extends Controller {
  static targets = ["langButton"]
  static values = { lang: String }

  connect() {
    console.log("ThemeLanguageController connected")
    this.initializeLanguage()
  }

  initializeLanguage() {
    const currentLang =
      document.documentElement.getAttribute("lang") ||
      window.localStorage.getItem("preferred-language") ||
      "ko"

    this.updateButtonStates(currentLang)

    const selector = this.element
    if (selector) {
      selector.style.opacity = "1"
      selector.style.transition = "opacity 0.3s ease-in-out"
    }
  }

  setLanguage(event) {

    const target = event.currentTarget
    const lang = event.params?.lang || target.dataset.lang

    console.log("Setting language to:", lang)
    
    if (!lang) return

    this.updateButtonStates(lang)

    window.localStorage.setItem("preferred-language", lang)
    document.documentElement.setAttribute("lang", lang)

    this.updateSession(lang)
  }

  updateButtonStates(lang) {
    const buttons = this.element.querySelectorAll("[data-lang]")

    buttons.forEach(button => {
      const buttonLang = button.dataset.lang
      const isActive = buttonLang === lang

      button.classList.remove(
        "text-gray-500",
        "hover:text-gray-700",
        "text-gray-700",
        "bg-white",
        "shadow-sm"
      )

      if (isActive) {
        button.classList.add("text-gray-700", "bg-white", "shadow-sm")
        button.style.transform = "scale(1.05)"
        window.setTimeout(() => {
          button.style.transform = "scale(1)"
        }, 150)
      } else {
        button.classList.add("text-gray-500", "hover:text-gray-700")
        button.style.transform = "scale(1)"
      }
    })
  }

  async updateSession(lang) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch("/update_locale", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/vnd.turbo-stream.html",
          ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {})
        },
        body: JSON.stringify({ locale: lang })
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: Session update failed`)
      }

      await response.text()
      window.location.reload()
    } catch (error) {
      console.error("Locale session update failed:", error)
      window.location.reload()
    }
  }
}
